"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getChar = exports.copyKeyboardEvent = exports.isTypeableCharacterEvent = exports.hasModifierKey = exports.isModifierKey = exports.isBackspace = exports.isDelete = exports.isNavigationKey = exports.isSpecialNavigationKey = exports.isArrowKey = exports.isPageDown = exports.isPageUp = exports.isEnd = exports.isHome = exports.isArrowRight = exports.isArrowLeft = exports.isArrowDown = exports.isArrowUp = exports.isEscape = exports.isTab = exports.isSpace = exports.isEnter = exports.getKeyCode = exports.isKey = void 0;
const UP_KEY_CODE = 38;
const DOWN_KEY_CODE = 40;
const ESCAPE_KEY_CODE = 27;
const ENTER_KEY_CODE = 13;
function isKey(event, ...matches) {
    return matches.includes(event.key);
}
exports.isKey = isKey;
/**
 * @deprecated uses deprecated JavaScript property access
 */
function getKeyCode(event) {
    return event.which || event.keyCode;
}
exports.getKeyCode = getKeyCode;
function isEnter(event) {
    return isKey(event, "Enter") || getKeyCode(event) === ENTER_KEY_CODE;
}
exports.isEnter = isEnter;
function isSpace(event) {
    return isKey(event, "Spacebar", " ");
}
exports.isSpace = isSpace;
function isTab(event) {
    return isKey(event, "Tab");
}
exports.isTab = isTab;
function isEscape(event) {
    return isKey(event, "Esc", "Escape") || getKeyCode(event) === ESCAPE_KEY_CODE;
}
exports.isEscape = isEscape;
function isArrowUp(event) {
    return isKey(event, "Up", "ArrowUp") || getKeyCode(event) === UP_KEY_CODE;
}
exports.isArrowUp = isArrowUp;
function isArrowDown(event) {
    return isKey(event, "Down", "ArrowDown") || getKeyCode(event) === DOWN_KEY_CODE;
}
exports.isArrowDown = isArrowDown;
function isArrowLeft(event) {
    return isKey(event, "Left", "ArrowLeft");
}
exports.isArrowLeft = isArrowLeft;
function isArrowRight(event) {
    return isKey(event, "Right", "ArrowRight");
}
exports.isArrowRight = isArrowRight;
function isHome(event) {
    return isKey(event, "Home");
}
exports.isHome = isHome;
function isEnd(event) {
    return isKey(event, "End");
}
exports.isEnd = isEnd;
function isPageUp(event) {
    return isKey(event, "PageUp");
}
exports.isPageUp = isPageUp;
function isPageDown(event) {
    return isKey(event, "PageDown");
}
exports.isPageDown = isPageDown;
function isArrowKey(event) {
    return isArrowUp(event)
        || isArrowRight(event)
        || isArrowDown(event)
        || isArrowLeft(event);
}
exports.isArrowKey = isArrowKey;
function isSpecialNavigationKey(event) {
    return isPageUp(event)
        || isEnd(event)
        || isPageDown(event)
        || isHome(event);
}
exports.isSpecialNavigationKey = isSpecialNavigationKey;
function isNavigationKey(event) {
    return isArrowKey(event) || isSpecialNavigationKey(event);
}
exports.isNavigationKey = isNavigationKey;
function isDelete(event) {
    return isKey(event, "Delete");
}
exports.isDelete = isDelete;
function isBackspace(event) {
    return isKey(event, "Backspace");
}
exports.isBackspace = isBackspace;
function isModifierKey(event) {
    return isKey(event, "Meta") ||
        isKey(event, "Control") ||
        isKey(event, "Shift") ||
        isKey(event, "Alt");
}
exports.isModifierKey = isModifierKey;
function hasModifierKey(event) {
    return event.metaKey || event.altKey || event.shiftKey || event.ctrlKey;
}
exports.hasModifierKey = hasModifierKey;
function isTypeableCharacterEvent(event) {
    return event.key && event.key.length === 1 && !event.ctrlKey;
}
exports.isTypeableCharacterEvent = isTypeableCharacterEvent;
function copyKeyboardEvent(event) {
    const properties = {};
    Object.assign(properties, event);
    return new KeyboardEvent(event.type, properties);
}
exports.copyKeyboardEvent = copyKeyboardEvent;
function getChar(event) {
    return event.key || String.fromCharCode(getKeyCode(event));
}
exports.getChar = getChar;
//# sourceMappingURL=KeyboardEventCodes.js.map